(() => {
  const cfg = window.vcHoeHeaderConfig || {};
  let panel = null;
  let overlay = null;
  let open = false;

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  const position = () => {
    if (isMobile()) return;
    const header = document.querySelector('#header-component .header__row') || document.querySelector('#header-component');
    const bottom = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;
    if (panel) panel.style.top = bottom + 'px';
    if (overlay) overlay.style.top = bottom + 'px';
  };

  const setOpen = (state) => {
    open = state;
    if (open) position();
    if (panel) {
      if (isMobile()) panel.style.top = '';
      panel.classList.toggle('is-open', open);
    }
    if (overlay) overlay.classList.toggle('is-open', open && !isMobile());
    document.documentElement.classList.toggle('vc-mega-lock', open && isMobile());
    document.documentElement.classList.toggle('vc-mega-open', open);
    const btn = document.querySelector('.vc-hnav [data-vc-shop]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const buildPanel = () => {
    if (document.getElementById('vc-mega')) {
      panel = document.getElementById('vc-mega');
      return;
    }
    const tpl = document.getElementById('vc-mega-template');
    if (!tpl) return;
    document.body.appendChild(tpl.content.cloneNode(true));
    panel = document.getElementById('vc-mega');
    overlay = document.createElement('div');
    overlay.className = 'vc-mega-overlay';
    document.body.appendChild(overlay);
    if (panel) {
      panel.removeAttribute('hidden');
      const closeBtn = panel.querySelector('.vc-mega__close');
      if (closeBtn) closeBtn.addEventListener('click', () => setOpen(false));
    }
    if (overlay) overlay.addEventListener('click', () => setOpen(false));
  };

  const ensureNav = () => {
    if (document.querySelector('.vc-hnav')) return;
    const drawerEl = document.querySelector('header-drawer');
    if (!drawerEl || !drawerEl.parentElement) return;

    const nav = document.createElement('nav');
    nav.className = 'vc-hnav';
    nav.setAttribute('aria-label', 'Main');

    const shopBtn = document.createElement('button');
    shopBtn.type = 'button';
    shopBtn.className = 'vc-hnav__link';
    shopBtn.setAttribute('data-vc-shop', '');
    shopBtn.setAttribute('aria-expanded', 'false');
    shopBtn.setAttribute('aria-label', 'Menu');

    const burger = document.createElement('span');
    burger.className = 'vc-hnav__burger';
    burger.setAttribute('aria-hidden', 'true');
    shopBtn.appendChild(burger);

    const label = document.createElement('span');
    label.className = 'vc-hnav__label';
    label.textContent = cfg.label1 || 'Shop';
    shopBtn.appendChild(label);

    shopBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      setOpen(!open);
    });
    nav.appendChild(shopBtn);

    if (cfg.label2) {
      const collLink = document.createElement('a');
      collLink.className = 'vc-hnav__link';
      collLink.href = cfg.url2 || '/collections';
      collLink.textContent = cfg.label2;
      nav.appendChild(collLink);
    }

    drawerEl.insertAdjacentElement('afterend', nav);
  };

  const start = () => {
    buildPanel();
    ensureNav();

    const headerEl = document.querySelector('#header-component');
    if (headerEl) {
      new MutationObserver(() => ensureNav()).observe(headerEl, { childList: true, subtree: true });
    }
    setInterval(ensureNav, 2000);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && open) setOpen(false);
    });

    document.addEventListener('click', (e) => {
      if (!open) return;
      if (panel && panel.contains(e.target)) return;
      if (e.target.closest && e.target.closest('.vc-hnav')) return;
      if (isMobile()) return;
      setOpen(false);
    });

    window.addEventListener('scroll', () => {
      if (open && !isMobile()) setOpen(false);
    }, { passive: true });

    window.addEventListener('resize', () => {
      if (open) position();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

// VC – search: results only while typing, and very high-res images
(() => {
  const modalSel = 'dialog-component.search-modal';

  const syncTyping = () => {
    const modal = document.querySelector(modalSel);
    if (!modal) return;
    const inp = modal.querySelector('.search-input');
    const typing = !!(inp && inp.value && inp.value.trim().length > 0);
    modal.classList.toggle('vc-typing', typing);
  };

  const fix = (img) => {
    if (!img || img.dataset.vcHq) return;
    img.dataset.vcHq = '1';
    img.setAttribute('sizes', '(max-width: 749px) 50vw, 25vw');

    const bump = (urlStr) => {
      try {
        const u = new URL(urlStr, location.origin);
        if (u.searchParams.has('width')) {
          u.searchParams.set('width', '1400');
          return u.toString();
        }
      } catch (e) { /* no-op */ }
      return '';
    };

    const srcset = img.getAttribute('srcset') || '';
    if (srcset) {
      let maxW = 0;
      let firstUrl = '';
      srcset.split(',').forEach((part) => {
        const bits = part.trim().split(' ');
        if (!firstUrl) firstUrl = bits[0];
        const w = parseInt((bits[1] || '').replace('w', ''), 10) || 0;
        if (w > maxW) maxW = w;
      });
      if (maxW > 0 && maxW < 1200 && firstUrl) {
        const hq = bump(firstUrl);
        if (hq) img.setAttribute('srcset', srcset + ', ' + hq + ' 1400w');
      }
      return;
    }

    const src = img.getAttribute('src') || '';
    if (src) {
      const hq = bump(src);
      if (hq) img.src = hq;
    }
  };

  const run = () => {
    const modal = document.querySelector(modalSel);
    if (!modal) return;
    syncTyping();
    modal.querySelectorAll('img').forEach(fix);
  };

  const start = () => {
    run();
    const modal = document.querySelector(modalSel);
    if (modal) {
      new MutationObserver(run).observe(modal, { childList: true, subtree: true });
    }
    document.addEventListener('input', (e) => {
      if (e.target && e.target.matches && e.target.matches('.search-modal .search-input')) {
        syncTyping();
      }
    }, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

// VC – search results page (Enter): heading becomes N RESULTS FOR "QUERY", HoE style
(() => {
  const init = () => {
    if (location.pathname.indexOf('/search') === -1) return;
    const q = new URLSearchParams(location.search).get('q') || '';
    if (!q) return;

    let count = '';
    const parts = document.title.split(' ');
    for (const p of parts) {
      const n = parseInt(p, 10);
      if (!isNaN(n)) { count = String(n); break; }
    }

    const headings = document.querySelectorAll('h1, h2, h3');
    for (const h of headings) {
      if ((h.innerText || '').trim().toLowerCase() === 'search results') {
        const label = count === '' ? 'Results' : count + (count === '1' ? ' result' : ' results');
        h.textContent = label + ' for "' + q + '"';
        break;
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();